import { useState } from 'react'
import { useRouter } from 'next/router'
import { useGetCheckoutSession } from '~workspace/queries/useGetCheckoutSession'
import { useGetCurrentWorkspace } from '~workspace/queries/useGetWorkspaceById'
import { UpgradeTab as View } from 'ui-components'

export function Upgrade() {
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()
  const mutation = useGetCheckoutSession()
  const { data } = useGetCurrentWorkspace()

  const handleUpgrade = async (id, planName) => {
    if (!data) return
    setIsLoading(true)
    const response = await mutation.mutateAsync({
      input: {
        workspaceId: data.id,
        stripeProductPriceId: id,
        numberOfMembers: data.memberCollection.items.filter(
          (member) => member.role !== 'guest'
        ).length,
        workspaceName: data.name,
        plan: planName,
        workspaceOwnerEmail:
          data.memberCollection.items.find((member) => member.role === 'owner')
            ?.user.email || '',
        stripeCustomerId: data.stripeCustomerId || ''
      }
    })
    setIsLoading(false)
    router.push(response.url)
  }

  return <View onUpgrade={handleUpgrade} />
}
